import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelToSnakeUpper',
  standalone: true,
})
export class CamelToSnakeUpperPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return '';
    return value
      .replace(/([a-z])([A-Z])/g, '$1_$2') // Inserta guión bajo entre minúscula y mayúscula
      .toUpperCase(); // Convierte todo a mayúsculas
  }
}
